import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import { FontWeights, Skeleton, Text } from "@flat-ui";
import { getProjectNumbersInGroup } from "@utils/group-utils";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Grid size for a count that shares the row with another count */
const HALF_ROW_SIZE = 6;

/** Grid size for a count that spans the whole row */
const FULL_ROW_SIZE = 12;
/** A single labelled count of the group card bottom section. */
function GroupCardCount(t0) {
  const $ = _c(10);
  const {
    label,
    count,
    size,
    isLoading,
    hasDivider
  } = t0;
  const t1 = hasDivider ? `1px 0 0 0 ${PALETTE_VARS.divider}` : undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = {
      boxShadow: t1,
      display: "flex",
      flexFlow: "column",
      alignItems: "center"
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count || $[3] !== isLoading || $[4] !== label) {
    t3 = isLoading ? <Skeleton variant="rectangular" width="50px" height="40px" /> : <><Text variant="heading20" sx={{
        color: "text.secondary",
        fontSize: "20px",
        fontWeight: FontWeights.SemiBold,
        lineHeight: "20px",
        paddingBottom: "4px"
      }}>{count}</Text><Text variant="bodyS" sx={{
        color: "text.secondary",
        fontSize: "12px",
        lineHeight: "16px"
      }}>{label}</Text></>;
    $[2] = count;
    $[3] = isLoading;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== size || $[7] !== t2 || $[8] !== t3) {
    t4 = <Grid sx={t2} size={size}>{t3}</Grid>;
    $[6] = size;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}

/**
 * Bottom section of the group card that shows the number of group manager and number of projects.
 * Workspaces that cannot assign managers only see the number of projects.
 */
export function GroupCardBottom(t0) {
  const $ = _c(13);
  const {
    group,
    isLoading
  } = t0;
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let t1;
  if ($[0] !== canAssignManagers || $[1] !== group?.numManagers || $[2] !== isLoading) {
    t1 = canAssignManagers && <GroupCardCount label="Managers" count={group?.numManagers ?? "0"} size={HALF_ROW_SIZE} isLoading={isLoading} hasDivider={true} />;
    $[0] = canAssignManagers;
    $[1] = group?.numManagers;
    $[2] = isLoading;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== group) {
    t2 = group ? getProjectNumbersInGroup(group) : "0";
    $[4] = group;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = canAssignManagers ? HALF_ROW_SIZE : FULL_ROW_SIZE;
  let t4;
  if ($[6] !== isLoading || $[7] !== t2 || $[8] !== t3) {
    t4 = <GroupCardCount label="Projects" count={t2} size={t3} isLoading={isLoading} />;
    $[6] = isLoading;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <Grid container={true}>{t1}{t4}</Grid>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}